import List from '../modules/quote_table/list'

declare var Swiper;

var data = {
    refresh_time: 10,
    quotaConfig: {
        host: '//push2.eastmoney.com',
        unpPath: '/api/qt/ulist.np/get',
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        cPath: '/api/qt/clist/get'
    },
    init:function(){
        let self = this
        self.initTit()
        self.getData(self.gethushenzhishu(), self.bindSwiperData)
        self.makeList1()
        self.makeList2()
        self.makeList3()
        self.makeList4()
        if (self.refresh_time > 0) {
            clearInterval(self.timer)
            self.timer = setInterval(() => {
                self.refresh()
            }, self.refresh_time * 1000);
        }
    },
    // 沪深指数 Ajax 请求地址
    gethushenzhishu: function () {
        let self = this
        let ids = "1.000001,1.000016,100.FTSE,1.000010,100.MCX,100.AXX";
        let url = self.quotaConfig.host + self.quotaConfig.unpPath
            + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids
            + "&ut=" + self.quotaConfig.token + "&forcect=1";
        return url
    },
    // Ajax 请求
    getData: function (url, callback) {
        let self = this
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                //-> data: 就是我们从服务器获取的数据，然后执行第四步的bindHTML方法
                callback(data, self)
            }
        })
    },
    // 给 Swiper 绑定数据
    bindSwiperData: function (data, self) {
        if (data.rc == 0) {
            let _class = ''
            let _siwper_html = ''
            data.data.diff.forEach((item, index) => {
                if (index == 0) {
                    _class = 'swiper-slide swiper-slide-active'
                } else if (index == 1) {
                    _class = 'swiper-slide swiper-slide-next'
                } else {
                    _class = 'swiper-slide'
                }
                _siwper_html += `<div class="${_class}">
                                <div class="zs-wrap">
                                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                    <p>${item.f14}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                                        <span>${self.numberFix(item.f4,2)}</span>
                                        <span>${self.dataProcess(item.f3,2,'%')}</span>
                                    </p>
                                </a>
                            </div>
                        </div>`
            })
            $('#hushenzhishu').html(_siwper_html)
            new Swiper('.hqq-swiper', {
                direction: 'horizontal',
                slidesPerGroup: 3,
                slidesPerView: 3,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.go-nuxt',
                    prevEl: '.go-pre',
                }
            })
        }
    },
    // Swiper 数据刷新
    refreshSwiperData: function (data,self) {
        let _dom = $('#hushenzhishu').find('.swiper-slide')
        if (data.rc == 0) {
            data.data.diff.forEach((item, index) => {
                _dom[index].innerHTML = `<div class="zs-wrap">
                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                    <p>${item.f14}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                        <span>${self.numberFix(item.f4,2)}</span>
                        <span>${self.dataProcess(item.f3,2, '%')}</span>
                    </p>
                </a>
            </div>`
            })
        }
    },
    refresh: function () {
        let self = this
        let url = self.gethushenzhishu()
        self.getData(url, self.refreshSwiperData)
    },
    initTit:function(){
        $.ajax({
            url: '//push2.eastmoney.com/api/qt/ulist.np/get?ut=bd1d9ddb04089700cf9c27f6f7426281&secids=16001.VIDX_HLTGDR,16001.VIDX_HLTCDR&fields=f104,f105,f106',
            type: 'get',
            dataType: 'json',
            success: function (data) {
                let res = data.data.diff
                let gdrsum = res[0].f104+res[0].f105+res[0].f106 //gdr 104 105 106
                let cdrsum = res[1].f104+res[1].f105+res[1].f106 //cdr
                let gdr = `
                    <span class="gp-asc">涨${gdrsum > 0 ? res[0].f104 : '--'}</span>
                    <span>平${gdrsum > 0 ? res[0].f106 : '--'}</span>
                    <span class="gp-des">跌${gdrsum > 0 ? res[0].f105 : '--'}</span>
                    <a href="/quote/hqlist.html?mt=huluntong_gdr">
                        <i class="arrow-right-new"></i>
                    </a>
                `
                $("#hlt-list-tit-gdr").html(gdr)
                let cdr = `
                    <span class="gp-asc">涨${cdrsum > 0 ? res[1].f104 : '--'}</span>
                    <span>平${cdrsum > 0 ? res[1].f106 : '--'}</span>
                    <span class="gp-des">跌${cdrsum > 0 ? res[1].f105 : '--'}</span>
                    <a href="/quote/hqlist.html?mt=huluntong_cdr">
                        <i class="arrow-right-new"></i>
                    </a>
                `
                $("#hlt-list-tit-cdr").html(cdr)
            }
        })
    },
    makeList1:function(){
        let self = this
        let List1 = new List({
            ele:'hlt-list-gdr',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148&pn=1&pz=10&fid=f3&po=1&fs=b:MK0815&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 10,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,2,'%')}</div>
                    </a>
                </dd>
                `
            },
            error:function(data){
                console.log(data)
            }
        })
        List1.init()
    },
    makeList2:function(){
        let self = this
        let List2 = new List({
            ele:'hlt-list-cdr',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148&pn=1&pz=10&fid=f3&po=1&fs=m:1+e:31&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 10,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,2,'%')}</div>
                    </a>
                </dd>
                `
            },
            error:function(data){
                return `
                    <div class="list-no-data">
                        <div class="no-data-icon"></div>
                        <p>当前暂无对应品种</p>
                    </div>
                `
            }
        })
        List2.init()
    },
    makeList3:function(){
        let self = this
        let List3 = new List({
            ele:'hlt-list-gdra',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f117,f118,f119,f120,f148,f152,f186,f187,f188,f189,f190&pn=1&pz=10&fid=f3&po=1&fs=b:MK0815&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 10,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f117,data.f120)}</p>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f118,data.f152,'%')}</p>
                        </div>
                        <div>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</p>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,data.f152,'%')}</p>
                        </div>
                        <div class=${data.f119 > 0 ? 'shares-rise' : (data.f119 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f119,data.f152,'%')}</div>
                    </a>
                </dd>
                `
            },
            error:function(data){
                return `
                    <div class="list-no-data">
                        <div class="no-data-icon"></div>
                        <p>当前暂无对应品种</p>
                    </div>
                `
            }
        })
        List3.init()
    },
    makeList4:function(){
        let self = this
        let List4 = new List({
            ele:'hlt-list-cdra',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f117,f118,f119,f120,f148,f152,f186,f187,f188,f189,f190&pn=1&pz=10&fid=f3&po=1&fs=m:1+e:31&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 10,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f117,data.f120)}</p>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f118,data.f152,'%')}</p>
                        </div>
                        <div>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</p>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,data.f152,'%')}</p>
                        </div>
                        <div class=${data.f119 > 0 ? 'shares-rise' : (data.f119 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f119,data.f152,'%')}</div>
                    </a>
                </dd>
                `
            },
            error:function(data){
                return `
                    <div class="list-no-data">
                        <div class="no-data-icon"></div>
                        <p>当前暂无对应品种</p>
                    </div>
                `
            }
        })
        List4.init()
    },
    conversion(num: number, isSign: boolean, isUnit: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
            if (num < 0) {
                numSign = '-'
            } else if (num == 0) {
                numSign = ''
            } else {
                numSign = '+'
            }
        } else {
            numSign = ''
        }
        if (Math.abs(num) == 0) {
            return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
            return numSign + self.numberFix(Math.abs(num), 3)
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
            return numSign + self.numberFix(Math.abs(num), 2)
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
            return numSign + self.numberFix(Math.abs(num), 1)
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
            return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2) + '万亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2)
            }
        } else if (Math.abs(num) >= 10000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2) + '万亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2)
            }
        } else {
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
            return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
            return f
        } else {
            var s = f.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + n) {
                s += '0';
            }
            return s;
        }
    },
    dataProcess(data,num,symbol) {
        let self = this
        if (data == undefined || data == null || data == '-') {
            return '-'
        } else {
            return self.numberFix(data, num) + symbol
        }
    }
}

data.init()